import { Box, SxProps } from '@mui/material';
import { useTrackIntersection } from '@/shared/utils';
import React from 'react';

import { Oject, RowComponentType } from '../types';
import { useObserver } from '../useObserver';
import { RequiredAny } from 'ui-kit/lib/types';

const sx: Partial<Record<string, SxProps>> = {
  row: {
    display: 'grid',
    cursor: 'pointer',
    '-webkit-tap-highlight-color': 'transparent',
    fontWeight: 400,
    '& > *': {
      alignSelf: 'center',
    },
    borderBottom: '1px solid #dff2f5',
    columnGap: 24,
    padding: '0px 36px',
  },
};

interface BodyType<T extends Oject> {
  data: T[];
  rowComponent: RowComponentType<T>;
  gridTemplateColumns: string;
  keyIndicator: keyof T;
  className?: string;
  scrollRest?: () => void;
  setIsScrollAbsolute?: (event: RequiredAny) => void;
  loading: boolean;
}

export const Body = <T extends Oject>({
  data,
  rowComponent,
  gridTemplateColumns,
  keyIndicator,
  className,
  scrollRest,
  loading,
  setIsScrollAbsolute,
}: BodyType<T>): React.JSX.Element => {
  const reference = React.useRef<HTMLDivElement | null>(null);
  const { component: Component, props } = rowComponent;
  useTrackIntersection({
    reference,
    callBack: setIsScrollAbsolute,
    threshold: 0,
  });

  useObserver(reference, scrollRest, loading);
  return (
    <>
      <Box>
        {data.map((object: RequiredAny, index) => (
          <Component
            sx={sx.row}
            data={object}
            className={className ? `${className} ` : ''}
            gridTemplateColumns={gridTemplateColumns}
            key={`${object[keyIndicator as string]}/table-component${index}`}
            {...props}
          />
        ))}
      </Box>
      <Box ref={reference} />
    </>
  );
};
